module.exports = __webpack_public_path__ + "static/img/left-top-row-4.1bb7f074.png";